import { Controller } from 'stimulus';

// Generic tab switcher for UI::Tabs: highlights the clicked tab, reveals its
// panel and (optionally) mirrors the active tab key into a URL query param so
// the selection survives refreshes and can be deep-linked.
export default class extends Controller {
  static targets = ['tab', 'panel'];
  static values = {
    urlParam: String,
    activeClasses: String,
    inactiveClasses: String,
  };

  activate(event) {
    this.show(event.currentTarget.dataset.key);
  }

  show(key) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.key === key;

      tab.classList.remove(
        ...this.classList(active ? this.inactiveClassesValue : this.activeClassesValue)
      );
      tab.classList.add(
        ...this.classList(active ? this.activeClassesValue : this.inactiveClassesValue)
      );
      tab.setAttribute('aria-selected', active);
    });

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.key !== key);
    });

    this.updateUrl(key);
    this.dispatch('shown', { detail: { key } });
  }

  classList(classes) {
    return classes.split(' ').filter(Boolean);
  }

  updateUrl(key) {
    if (!this.urlParamValue) {
      return;
    }

    const url = new URL(window.location);
    url.searchParams.set(this.urlParamValue, key);
    window.history.replaceState({}, '', url);
  }
}
